/*
 * @@Description: 垂直滚动
 * @@Author: MuYang
 * @Date: 2021-08-09 17:26:56
 * @LastEditTime: 2021-10-14 14:02:34
 */
import ScrollBar from './bar'
import getScrollBarWidth from './scroll-width'
import { assign } from '../../util'
// import { offset } from '../../../../../utils/dom'
/* 水平滚动 */
export default {
  name: 'horizontal-scroll',
  props: {
    // isScrollBar: {
    //   type: Boolean,
    //   default: true
    // },
    refer: {
      default: 'sy-virtual-table'
    },
    customFn: {}
  },
  data () {
    return  {
      isScrollBar: false
    }
  },
  computed: {
    className () {
      return this.isScrollBar
        ? ' sy-scroll-horizontal sy-scroll no-scroll-strip'
        : ' sy-scroll-horizontal sy-scroll'
    }
  },
  methods: {
    handleScroll (event) {
      this.$emit('horizontalScroll', event)
    }
  },
  render (h) {
    const { className } = this
    const children = this.$slots.default[0]
    if (!children.data) {
      children.data = {}
    }
    children.data.class = children.data.class
      ? children.data.class + className
      : className
    children.data.on = assign({ scroll: this.handleScroll }, children.data.on)

    // ie9
    if (navigator.userAgent.indexOf('MSIE 9.0') !== -1) {
      const scrollBarWidth = getScrollBarWidth()
      children.data.style = assign(
        { marginBottom: `-${scrollBarWidth}px` },
        children.data.style
      )
    }

    return children
  },
  destroyed () {
    this.scrollBar && this.scrollBar.destroyed()
  },
  mounted () {
    setTimeout(() => {
      const {width} = this.$el.getBoundingClientRect()
      const scrollWidth = this.$el?.scrollWidth
      if (scrollWidth > width) {
        this.isScrollBar = true
      }
      if (this.isScrollBar) {
        this.scrollBar = new ScrollBar(this.$el, {
          onScroll: this.handleScroll,
          refer: this.refer,
          type: 'horizontal'
        })
      }
    }, 0)
  }
}
